import React, { ReactNode } from "react";
import { Flex } from "../../atoms/flex";
import { Icon, IconType } from "../../atoms/icon";
import { Title } from "../../atoms/title";
import "./header.css";

interface HeaderProps {
  icon?: IconType;
  title?: string;
  subTitle?: string;
  className?: string;
  textAlignment?: "left" | "center" | "right";
  children?: ReactNode;
  loading?: boolean;
}

/**
 * Header component
 */
export const Header: React.FC<HeaderProps> = ({
  icon,
  title,
  subTitle,
  className,
  textAlignment = "center",
  children,
  loading,
}) => (
  <Flex className={`Header ${className || ""}`}>
    {children}
    <Icon type={icon} size="m" loading={loading} />
    <Title text={title} tag="h2" loading={loading} />
    <Title text={subTitle} tag="h3" loading={loading} />
  </Flex>
);
